export default __webpack_public_path__ + "static/media/P30004.2a1c77a2.png";